/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Volo_Abp_PermissionManagement_GetPermissionListResultDto } from '../models/Volo_Abp_PermissionManagement_GetPermissionListResultDto';
import type { Volo_Abp_PermissionManagement_UpdatePermissionsDto } from '../models/Volo_Abp_PermissionManagement_UpdatePermissionsDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PermissionsService {

    /**
     * @param providerName
     * @param providerKey
     * @returns Volo_Abp_PermissionManagement_GetPermissionListResultDto OK
     * @throws ApiError
     */
    public static getApiAwardApiPermissionManagementPermissions(
        providerName?: string,
        providerKey?: string,
    ): CancelablePromise<Volo_Abp_PermissionManagement_GetPermissionListResultDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/permission-management/permissions',
            query: {
                'providerName': providerName,
                'providerKey': providerKey,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param providerName
     * @param providerKey
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static putApiAwardApiPermissionManagementPermissions(
        providerName?: string,
        providerKey?: string,
        requestBody?: Volo_Abp_PermissionManagement_UpdatePermissionsDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/award/api/permission-management/permissions',
            query: {
                'providerName': providerName,
                'providerKey': providerKey,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
